import React, { createContext, useEffect, useReducer, useState } from 'react';

import { merge } from "lodash";
import SessionOut from "../../views/sessions/SessionOut";
import RequestDialog from "../../components/RequestDialog";
import axios from '../../../axios';

const initialValue = {
    users: [],
    vendors: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_USER_TOKENS': {
            const marged = merge({}, state.tokens, action.payload);
            return {
                ...state,
                tokens: marged
            }
        }
        case 'LOAD_VENDOR_TOKENS': {
            const marged = merge({}, state.tokens, action.payload);
            return {
                ...state,
                tokens: marged
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        case 'BAD_REQUEST': {
            return {
                ...state,
                status: 400,
                message: action.message
            }
        }
        default: {
            return state
        }
    }
}

const SendNotificationContext = createContext({
    tokens: initialValue,
    sendNotification: () => {},
    sendNotificationProduct: () => {},
    getUserTokens: () => {},
    getVendorTokens: () => {},
    uploadImage: () => {},
})

export const SendNotificationProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const [open, setOpen] = useState(false);

    const uploadImage = async (data) => {
        try {
            const options = {
                headers : {'Content-Type': 'multipart/form-data'}
            }

            const res = await axios.post('/api/upload_product_image', data, options);

            return res.data;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: e.response?.data?.message??"Something wrong on server"
                })
            }else if(e.response.status === 500){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: "Server timeout."
                })
            }
            return null;
        }
    }

    const sendNotification = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')
        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            await axios.post('/api/notifications/send_notification', data, options);

        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: e.response?.data?.message??"Something wrong on server"
                })
            }else if(e.response.status === 500){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: "Server timeout."
                })
            }
        }
    }

    const sendNotificationProduct = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')
        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/notifications/send_notification_product', data, options);
            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: e.response?.data?.message??"Something wrong on server"
                })
            }else if(e.response.status === 500){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: "Server timeout."
                })
            }
            return  e;
        }
    }

    const getUserTokens = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/notifications/get_user_tokens', options);

            dispatch({
                type: 'LOAD_USER_TOKENS',
                payload: res.data,
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: e.response?.data?.message??"Something wrong on server"
                })
            }else if(e.response.status === 500){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: "Server timeout."
                })
            }
        }
    }

    const getVendorTokens = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/notifications/get_vendor_tokens', options);

            dispatch({
                type: 'LOAD_VENDOR_TOKENS',
                payload: res.data,
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: e.response?.data?.message??"Something wrong on server"
                })
            }else if(e.response.status === 500){
                setOpen(true)
                dispatch({
                    type: 'BAD_REQUEST',
                    message: "Server timeout."
                })
            }
        }
    }

    useEffect(() => {
        getUserTokens();
        getVendorTokens();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if(state.status === 401){
        return <SessionOut />
    }

    if(state.status === 400){
        return <RequestDialog state={state} open={open} setOpen={setOpen} title={"Error"} message={state.message}/>
    }

    return (
        <SendNotificationContext.Provider
            value={{
                tokens: state.tokens,
                uploadImage,
                sendNotification,
                sendNotificationProduct,
                getUserTokens,
                getVendorTokens
            }}
        >
            {children}
        </SendNotificationContext.Provider>
    )
}

export default SendNotificationContext
